/** 预约送货列表*/
export const API_GET_SUPPLIER_BOOKING_DELIVERY_LIST = {
  url: 'supplier/booking/delivery/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 预约详情*/
export const API_GET_SUPPLIER_BOOKING_DELIVERY_DETAILS = {
  url: 'supplier/booking/delivery/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 获取可预约时段*/
export const API_GET_SUPPLIER_BOOKING_DELIVERY_FREE_TIME = {
  url: 'supplier/booking/delivery/free/time',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 选择订货通知单列表*/
export const API_GET_SUPPLIER_BOOKING_DELIVERY_ORDER_LIST = {
  url: 'supplier/booking/delivery/order/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 取消预约*/
export const API_POST_SUPPLIER_BOOKING_DELIVERY_CANCEL = {
  url: 'supplier/booking/delivery/cancel',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 仅预约*/
export const API_POST_SUPPLIER_BOOKING_DELIVERY_CREATE = {
  url: 'supplier/booking/delivery/create',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 预约并发货*/
export const API_POST_SUPPLIER_BOOKING_DELIVERY_CREATEANDSENDGOODS = {
  url: 'supplier/booking/delivery/createAndSendGoods',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 下载验收文件*/
export const API_POST_PURCHASE_NOTICE_ORDER_DOWNLOAD = {
  url: '/purchase/notice/order/downLoad',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 要货地点*/
export const API_GET_PUBLIC_SHOP_LIST_AUTH = {
  url: 'public/shop/list/auth',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 订货通知单详情*/
export const API_GET_PURCHASE_NOTICE_ORDER_DETAILS_BYORDERNUMBER = {
  url: 'purchase/notice/order/details/byOrderNumber',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 重新发货*/
export const API_GET_PURCHASE_NOTICE_RESEND_GOODS = {
  url: 'purchase/notice/resend/goods',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 预采单_列表*/
export const API_POST_PREPURCHASE_NOTICE_LIST = {
  url: 'pre/purchase/notice/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 预采单_列表*/
export const API_POST_PREPURCHASE_NOTICE_BOARD_LIST = {
  url: 'pre/purchase/notice/board',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 预采单_列表数量*/
export const API_POST_INTENTION_COUNT = {
  url: 'pre/purchase/notice/tab/count',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 预采单_列表数量*/
export const API_POST_INTENTION_EXPORT = {
  url: 'pre/purchase/notice/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 预采单_列表数量*/
export const API_POST_INTENTION_DETAIL = {
  url: 'pre/purchase/notice/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 预采单_列表数量*/
export const API_POST_INTENTION_READ = {
  url: 'pre/purchase/notice/read',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};
